import { render, staticRenderFns } from "./PesquisaSchema.vue?vue&type=template&id=9c6fb740"
import script from "./PesquisaSchema.vue?vue&type=script&lang=js"
export * from "./PesquisaSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports